{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "Elimina e rimuovi dal progetto | Elimina e rimuovi dai progetti",
        "unsavedChanges": "Modifiche non salvate!",
        "areYouSureYouWantToRemovePage": "Elimina '{pageName}'.",
        "deleteStyle": "Elimina stile?",
        "deleteMedia": "Elimina media?",
        "deleteMediaImplications": "Eliminare e rimuovere dai progetti?",
        "deletePlayer": "Elimina dispositivo?",
        "deletePlayerImplications": "Questa azione rimuoverà il dispositivo dal tuo account ARYA ed eliminerà tutte le impostazioni relative a questo dispositivo, incluse tutte le programmazioni.",
        "permanentlyDeleteTheUserAccount": "Elimina account.",
        "removeTemplate": "Rimuovi template",
        "removeTemplateDesc": "Vuoi rimuovere questo template da questo stile?",
        "removeTheMediaFromTheSchedule": "Elimina dalla programmazione.",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Elimina media.",
        "mediaUsedInProject": "Media in uso nel progetto | Media in uso nei progetti",
        "confirmPassword": "Conferma password",
        "changeEmail": "Modifica email",
        "deleteOrder": "Elimina ordine",
        "deleteTag": "Eliminare il tag?",
        "deletePopId": "Eliminare il PoP ID?",
        "deleteUser": "Eliminare l'utente?",
        "deleteAccount": "Eliminare l'account?",
        "leaveAccount": "Lasciare l'account?",
        "deleteCanvasResolution": "Eliminare la risoluzione del canvas?",
        "downloadLicense": "Scaricare la licenza?",
        "cancelOrder": "Annullare l'ordine?",
        "removeAccessFromArya": "Rimuovere l'accesso da ARYA?",
        "deleteTemplate": "Eliminare il modello?"
    },
    "signinup": {
        "new": "Nuovo in {productNameShort}?",
        "newUser": "Nuovo utente"
    },
    "label": {
        "aryaAccountID": "ID account Arya",
        "accountId": "ID account",
        "admin": "admin",
        "addPlayer": "Aggiungi dispositivo",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "Il codice {code} è già stato assegnato ad un altro account.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "Il codice {code} è già stato assegnato.",
        "account": "Account | Account",
        "accountInfo": "Informazioni account",
        "accountInformation": "Informazioni account",
        "accountName": "Nome account",
        "accountPlan": "Abbonamento account",
        "accountCorrespondent": "Corrispondente account",
        "accountIsDeleted": "L'account è stato eliminato",
        "activate": "attiva",
        "address": "indirizzo",
        "alert": "notifica | notifiche",
        "amount": "importo",
        "apply": "applica",
        "assign": "assegnatario | assegnatari",
        "audio": "audio",
        "auto": "auto",
        "basic": "basic",
        "bannerText1": "Manutenzione programmata",
        "bannerText2": "Effettueremo una manutenzione programmata il giorno {date} alle {time} per approssimativamente {approximateHours} ore. Ci scusiamo per qualsiasi disagio dovesse verificarsi durante questo periodo.",
        "bannerText3": "A causa delle modifiche in corso sul suo contenuto, {productName} non sarà disponibile durante il periodo di manutenzione, ma i dispositivi continueranno a mostrare il proprio contenuto.",
        "billing": "fatturazione",
        "billingDetails": "Dettagli fatturazione",
        "buy": "acquista",
        "comment": "commento",
        "companyInformation": "Informazioni sull'azienda",
        "contentNotSupported": "contenuto non supportato, clicca per maggiori informazioni.",
        "copy": "copia | copie",
        "configPending": "CONFIG IN ATTESA",
        "configError": "ERRORE DI CONFIG",
        "credentials": "credenzialis",
        "credentialsNotValid": "Credenziali non valide",
        "createStyle": "Crea stile",
        "createUserExistErrorMessage": "{email} è già un membro di questo account.",
        "createUserLimitReached": "Raggiunto limite utenti",
        "creditCard": "Carta di credito",
        "download": "Scarica",
        "extended": "esteso",
        "expirationDate": "Data di scadenza",
        "expires": "scade",
        "keyboardShortcuts": "Scorciatoie da tastiera",
        "language": "Lingua",
        "learnMore": "maggiori informazioni",
        "leaveAccount": "Abbandona account",
        "leaveAccountWithOnlyOneUserMessage": "Non puoi abbandonare l'account perché sei l'unico utente dell'account.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "Non puoi abbandonare l'account perché sei l'unico amministratore dell'account.",
        "leaveAccountImplicationsCommonMessage": "Questa azione ti rimuoverà da questo account.",
        "license": "licenza",
        "limited": "limitata",
        "location": "Ubicazione",
        "login": "Accedi",
        "loginError": "Qualcosa è andato storto. In questo momento non siamo in grado di farti effettuare l'accesso: ti preghiamo di riprovare più tardi o di contattare l'amministratore.",
        "loginWith": "Accedi con",
        "loginString2": "Contenuto subito su schermo. Libero.",
        "loginString3": "La semplicità incontra la Digital Signage.",
        "loginString4": "Ordina e attiva set di funzionalità senza interruzioni",
        "loginOKStringTitle2": "La semplicità incontra lo Smart Sync.",
        "loginOKStringDesc1": "Personalizzalo. Programmalo. Rendilo una priorità.",
        "loginOKStringDesc2": "Etichettalo. Gestiscilo con Smart Sync. Invia notifica se necessario.",
        "loginOKString4": "Prossimo passo. Impostazione rapida del dispositivo.",
        "loginOKString5": "Ti serve solo il numero di serie del tuo dispositivo.",
        "loginOKQuotaWarnMain": "Spazio di archiviazione gratuito pieno al {percentage}%.",
        "loginOKQuotaWarnSub": "Passa a {plan} per ottenere template e notifiche interamente personalizzabili, 10GB di archiviazione per dispositivo, 10 utenti, Smart Sync per le etichette e molto altro.",
        "loginOKQuotaReachedMain": "Spazio di archiviazione gratuito pieno al {percentage}%.",
        "loginOKQuotaReachedSub": "Passa a {plan} per ottenere template e notifiche interamente personalizzabili, 10GB di archiviazione per dispositivo, 10 utenti, Smart Sync per le etichette e molto altro.",
        "loginOKQuotaExcededMain": "Spazio di archiviazione gratuito pieno.",
        "loginOKQuotaExcededSub": "Passa a {plan} er ottenere template e notifiche interamente personalizzabili, 10GB di archiviazione per dispositivo, 10 utenti, Smart Sync per le etichette e molto altro.",
        "logoutOKStringTitle1": "TI SEI DISCONNESSO",
        "logoutOKStringDesc1": "Puoi riconnetterti cliccando sul pulsante qui sotto.",
        "notice": "avviso",
        "playerSetupString1": "Crea il tuo progetto.",
        "playerSetupString2": "Facilissimo. Rapidissimo.",
        "playerSetupString3": "",
        "payments": "pagamenti",
        "pageNotFound": "Ci dispiace, pagina non trovata",
        "plan": "abbonamento | abbonamenti",
        "popIdentifier": "IDENTIFICAZIONE PoP",
        "postalCode": "Codice di avviamento postale",
        "purchasePlanUpgradeSuccessMain": "Benvenuto in {plan}",
        "purchasePlanDowngradeSuccessMain": "Account retrocesso a {planName}",
        "loggedOffInFewSeconds": "Tra pochi secondi verrai disconnesso",
        "termsOfServiceString1": "Termini di servizio",
        "termsOfServiceString2": "Ultimo aggiornamento: 9 January 2019",
        "termsOfServiceString3": "Si prega di scaricare e leggere il seguente documento",
        "termsOfServiceString4": "TERMINI DI SERVIZIO",
        "termsOfServiceString5": "POLITICA DI RISERVATEZZA",
        "termsOfServiceString6": "Selezione ACCETTA per proseguire.",
        "accept": "accetta",
        "all": "Tutti",
        "allPlayers": "Tutti i dispositivi",
        "add": "Aggiungi",
        "setPassword": "Conferma",
        "support": "assistenza",
        "cancel": "annulla",
        "canvasSize": "Dimensioni tela: {size} pixel",
        "canvasExistsError": "Esiste già una tela di queste dimensioni",
        "cardType": "tipo carta",
        "cardNumber": "numero carta",
        "change": "modifica",
        "clickToEdit": "clicca per modificare",
        "city": "città",
        "color": "colore | colori",
        "company": "azienda",
        "companyName": "Nome azienda",
        "confirm": "Conferma",
        "confirmation": "Conferma",
        "warning": "attenzione",
        "codeIsRequired": "Necessario codice di verifica",
        "code": "Codice",
        "contact": "contatto",
        "country": "nazione",
        "create": "Crea",
        "checkThePlayer": "Collegarsi a internet. Collegare l'alimentazione.",
        "checkDetails": "Verifica dettagli",
        "chooseHorizontalOrVerticalScreenOrientations": "Scegli orientamento schermo",
        "continue": "Continua",
        "conctactSystemAdmin": "Si prega di contattare il proprio amministratore di sistema.",
        "custom": "personalizzato",
        "customerInfo": "Informazioni cliente",
        "date": "data",
        "dropFilesHere": "Rilascia file qui",
        "deactivate": "disattiva",
        "default": "default",
        "delete": "elimina",
        "deleteAccount": "elimina account",
        "deleteUser": "elimina utente",
        "deleteOnAllPlayers": "ELIMINA da TUTTI I DISPOSITIVI.",
        "deleteFromSchedule": "Elimina da Programmazione",
        "demoVersion": "Versione demo",
        "disable": "disabilita",
        "disabled": "disabilitato",
        "distributor": "distributore",
        "downgradeAccount": "Retrocessione account",
        "downgradeTo": "Retrocedi a {plan}",
        "duplicate": "Duplica",
        "duplicateFile": "Duplica file",
        "duplicateInSchedule": "Duplica in Programmazione",
        "duration": "Durata",
        "adsDuration": "Durata annunci",
        "error": "errore",
        "email": "email",
        "emailAlreadyExists": "Un altro utente sta già utilizzando il nuovo indirizzo email: si prega di inserirne uno diverso.",
        "enable": "abilita",
        "enabled": "abilitato",
        "endDate": "Fine",
        "endTime": "Fine",
        "end": "fine",
        "edit": "Modifica",
        "editProject": "Modifica progetto",
        "feedbackForm": "Dai un feedback",
        "firstName": "Nome",
        "firmwareUpdate": "AGGIORNAMENTO FIRMWARE",
        "failed": "Contatta l'assistenza",
        "file": "File | File",
        "forgotPassword": "Password dimenticata",
        "formatNotSupported": "'{format}' file non supportati.",
        "firmware": "Firmware",
        "freeVersion": "Versione gratuita",
        "freeVersionNA": "Versione gratuita N/A",
        "get": "ottieni",
        "getCode": "Ottieni Config",
        "getConfig": "Ottieni Config",
        "generateNewAPIKey": "Genera nuova chiave API",
        "generateUserAPIKeyWarningMessage": "Questa azione renderà non valida la precedente chiave API e, per utilizzare la nuova chiave API, sarà necessario riconfigurare ogni connessione API esistente.",
        "goBack": "Indietro",
        "goToLogin": "Vai al login",
        "helpCenter": "Centro di Aiuto",
        "horizontalView": "Vista orizzontale",
        "image": "Immagine | Immagini",
        "implications": "implicazioni",
        "implicationsDeleteTag": "Questa azione eliminerà questa etichetta da tutti i {deleteFrom}. I tuoi permessi utente e le tue programmazioni potrebbero subire modifiche.",
        "implicationsDeleteLedTag": "Questa azione eliminerà questa etichetta da tutti i dispositivi. Per pubblicare nuovamente contenuti con questa risoluzione sarà necessario riconfigurare tutti i dispositivi che includevano questa etichetta.",
        "implicationsDeletePopId": "Questa azione eliminerà questo ID PoP da ogni ubicazione nella quale esso sia in uso.",
        "importantToNote": "Avviso importante",
        "logo": "logo",
        "userProfile": "Profilo utente",
        "userSignOut": "Disconnetti",
        "userNotConfirmed": "Utente non confermato",
        "userNotFound": "L'utente non esiste. Assicurati che questo account esista",
        "userManagement": "Gestione utente",
        "id": "id",
        "incorrectUsername": "Email non corretta",
        "incorrectPassword": "Password non corretta",
        "installedOrCapacity": "Installato / Spazio",
        "installed": "Installato",
        "installedOrCapacityUnlimitedMaxValue": "di dispositivi illimitati",
        "invalidEmail": "Email non valida",
        "invalidPassword": "Password non valida",
        "invalidUserdata": "Contatta assistenza",
        "invalidSerialNumber": "Numero di serie non corretto",
        "invalidDSOSTypeAmount": "Valore non valido. Si prega di inserire un numero.",
        "invalidResolution": "Risoluzione non valida",
        "invoice": "fattura | fatture",
        "inviteUser": "Invita utente",
        "requiredDeviceName": "Richiesto nome",
        "regular": "regolare",
        "resetPassword": "Reimposta la password",
        "loading": "caricamento...",
        "lastName": "Cognome",
        "lastLogin": "Ultimo accesso",
        "modify": "modifica",
        "monitoring": "monitoraggio",
        "newPassword": "Nuova password",
        "newPasswordRequiredWarning": "Imposta la tua password",
        "confirmNewPassword": "Conferma nuova password",
        "new": "Nuovo",
        "newCanvas": "Nuova tela",
        "newProject": "nuovo progetto",
        "newEmail": "Nuova email",
        "newResolution": "Nuova risoluzione",
        "name": "nome",
        "naText": "N/A",
        "next": "prossimo",
        "nextRenewalDate": "Prossimo rinnovo {renewalDate}",
        "noVideoAvailable": "Nessun video disponibile.",
        "noEmailProvided": "Nessuna email fornita",
        "none": "nessuno",
        "noSearchResults": "nessun risultato",
        "noPermissionToAccessThePage": "Accesso negato",
        "noPlayersInstalled": "Nessun dispositivo installato",
        "noPlayerGroupsAvailable": "Nessun gruppo dispositivi disponibile",
        "notConfigured": "Richiesta impostazione",
        "nameYourPlayerEGReception": "Dai un nome al tuo dispositivo, ad es. Accoglienza",
        "ok": "ok",
        "or": "oppure",
        "orders": "ordini",
        "order": "ordine | ordini",
        "offline": "Offline",
        "online": "online",
        "options": "opzioni",
        "page": "Pagina",
        "player": "dispositivo | dispositivi",
        "playerName": "Nome del player",
        "playerModel": "Modello del player",
        "playerGroups": "Gruppi di dispositivi",
        "pleaseEnterACity": "Inserisci città",
        "pin": "PIN",
        "pinShownOnYourScreen": "PIN mostrato sul tuo schermo",
        "playTime": "Tempo di riproduzione",
        "PleaseTryAgainOrHeadBackToTheHomepage": "Si prega di riprovare o di tornare alla pagina principale",
        "playerIsNotConnectedToTheCloud": "Numero di serie non corretto",
        "pleaseTryAgain": "Riprova",
        "pleaseEnterThePin": "Richiesto PIN",
        "pleaseEnterValidPin": "Inserisci il numero a 4 o 6 cifre mostrato sul tuo schermo",
        "pinMustBeFourDigitNumber": "Il PIN deve essere un numero da 4 a 6 cifre",
        "pinMustBeAtleastOneThousand": "Il PIN deve essere almeno 1000",
        "pleaseCheckYourEmailForVerificationCode": "Codice di verifica inviato al tuo indirizzo email",
        "password": "password",
        "passwordDidNotMatch": "La password non corrisponde",
        "passwordCannotBeReset": "Impossibile reimpostare la password",
        "passwordHasBeenChanged": "Password modificata",
        "passwordAttemptLimitExceeded": "Numero di tentativi esaurito, si prega di attendere e poi riprovare.",
        "passwordPolicyRequirementText": "La password deve contenere 8 o più caratteri, inclusi lettere maiuscole, lettere minuscole, numeri e caratteri speciali.",
        "price": "Prezzo",
        "priceSlashMonth": "Prezzo/Mese",
        "priority": "priorità",
        "privacy": "Privacy",
        "project": "Progetto | Progetti",
        "projectName": "Nome progetto",
        "profile": "Profilo",
        "proofOfPlay": "Prova di riproduzione",
        "preview": "Anteprima",
        "previewUnavailable": "Anteprima non disponibile",
        "proceed": "procedere ",
        "publishTo": "Pubblica su",
        "releaseNotes": "Note di rilascio",
        "remove": "rimuovere",
        "removeUserFromAccount": "rimuovere utente dall'account",
        "replace": "sostituire",
        "reporting": "segnalazioni",
        "reset": "reimpostare",
        "restart": "riavviare",
        "resolution": "risoluzione",
        "reactivate": "riattivare",
        "resetPasswordDescription": "Inserire email per ricevere codice di verifica",
        "resetPasswordCodeSent": "Codice di verifica inviato al tuo indirizzo email",
        "resetPasswordCodeSentIfAccountExist": "SE ACCOUNT ESISTE",
        "requiredAccountName": "Richiesto nome account",
        "requiredEmail": "Richiesta email",
        "requiredCountry": "Richiesta nazione",
        "requiredPassword": "Richiesta password",
        "requiredConfirmPassword": "Richiesta conferma password",
        "requiredFirstName": "Richiesto nome",
        "requiredLastName": "Richiesto cognome",
        "requiredName": "Richiesto nome",
        "requiredUsername": "Richiesta email",
        "requiredVerificationCode": "Richiesto codice di verifica",
        "requiredSerialNumber": "Richiesto numero di serie",
        "requiredCity": "Richiesta città",
        "requiredState": "Richiesta nazione",
        "requiredZipOrPostalCode": "Richiesto codice di avviamento postale",
        "requiredStreetAndNumber": "Richiesti via e numerod",
        "requiredCompanyName": "Richiesto nome azienda",
        "requiredDataStorageRegion": "Regione di archiviazione dati richiesta",
        "invalidDataStorageRegion": "Regione di archiviazione dati non valida",
        "review": "rivedere",
        "signOut": "disconnettere",
        "search": "cercare",
        "addressSearchPlaceholder": "Inserire indirizzo per localizzare dispositivi",
        "searching": "ricerca in corso",
        "status": "status",
        "save": "salvare",
        "reconfigure": "Riavviare impostazioni",
        "saveAs": "Salva come",
        "saveChanges": "Salva modifiche",
        "savedStyles": "Stili salvati",
        "schedule": "programmare",
        "scheduledToTag": "Programmato su etichetta",
        "screen": "schermo",
        "screenOn": "Schermo on",
        "screenOrientation": "Orientamento schermo",
        "security": "sicurezza",
        "sendCode": "Invia codice",
        "sendEmail": "inviare",
        "sendInvitation": "Invia invito",
        "sendTo": "Inviare a",
        "serial": "Numero di serie",
        "serialNumber": "Numero di serie",
        "serialNumberAlreadyAssigned": "Numero di serie già assegnato",
        "select": "SELEZIONARE",
        "selectAll": "seleziona tutto",
        "selectLanguage": "seleziona lingua",
        "setup": "Setup",
        "settings": "impostazioni",
        "shapeColors": "Forma colori",
        "shareWithText": "{productShortName} Digital Signage. Semplice. Smart. Potente.",
        "signIn": "Accesso",
        "signUp": "Registrati",
        "signUpErrorMessageAccountEmailExist": "Esiste già un profilo che utilizza l'indirizzo email fornito.",
        "slowSync": "SLOW SYNC ",
        "sorry": "Siamo spiacenti.",
        "streetAndNumber": "Via e numero",
        "success": "successo",
        "summary": "riepilogo",
        "somethingWentWrong": "Qualcosa è andato storto",
        "song": "Canzone | Canzoni",
        "startDate": "Data di inizio",
        "startTime": "Inizio",
        "start": "inizio",
        "state": "stato",
        "steps": "fasi",
        "styleName": "nome stile",
        "storage": "archiviazione",
        "subtotal": "subtotale",
        "subscription": "abbonamento",
        "subscriptionMonthlyAutoRenew": "Mensile (rinnovo automatico)",
        "ssoLoginErrorTitle": "Qualcosa è andato storto. In questo momento non siamo in grado di farti effettuare l'accesso: ti preghiamo di riprovare più tardi o di contattare l'amministratore.",
        "ssoMigrateAccountStep1Title1": "Esiste già un profilo che usa l'indirizzo {email}.",
        "ssoMigrateAccountStep1Title2": "Puoi passare all'utilizzo di SSO {provider}.",
        "ssoMigrateAccountStep1Title3": "Procedi per confermare il passaggio.",
        "ssoMigrateAccountStep2Title1": "Una volta che avrai confermato il passaggio verso SSO {provider}",
        "ssoMigrateAccountStep2Title2": "il tuo accesso precedente non funzionerà più.",
        "ssoMigrateAccountStep2Title3": "Non è possibile annullare questa azione.",
        "ssoMigrateAccountVerifyTitle1": "Dobbiamo verificare il tuo account {email} esistente.",
        "ssoMigrateAccountVerifyTitle2": "Si prega di accedere con detto account per procedere.",
        "tag": "etichetta | etichette",
        "defaultTags": "Tag predefiniti",
        "text": "testo",
        "deleteAccountWithMultipleUsersMessage": "Prima di poter eliminare questo account è necessario rimuovere tutti gli altri utenti.",
        "deleteAccountWithDistributorRightsMessage": "Impossibile eliminare questo account. Esso è di proprietà di un distributore.",
        "deleteAccountTitleThisActionWill": "Questa azione provocherà",
        "deleteAccountImplications": {
            "deleteAccount": "1. Eliminazione dell'account",
            "deleteUser": "2. Eliminazione dell'utente"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "Non puoi eliminare l'utente perché sei l'unico utente all'interno dell'account.",
        "timeZone": "Fuso orario",
        "time": "orario",
        "timeShorthandSecond": "SEC",
        "timeShorthandMinute": "MIN",
        "timeShorthandHour": "H",
        "template": "Template | Template",
        "temporaryPassword": "password temporanea",
        "tempPasswordExpiredPleaseContactAdmin": "Password temporanea scaduta. Si prega di contattarel'amministratore",
        "total": "totale",
        "tutorial": "Tutorial | Tutorial",
        "user": "utente | utenti",
        "userAPIKey": "Chiave API",
        "userNotActive": "Utente non attivo",
        "usernameShouldBeValidEmail": "Il nome utente deve impiegare un indirizzo email valido",
        "updatedAccountInfo": "Le informazioni del tuo account sono state aggiornate.",
        "updatedCustomerInfo": "Le tue informazioni cliente sono state aggiornate.",
        "updatedProfile": "Il tuo profilo utente è stato aggiornato.",
        "updated": "aggiornato",
        "upload": "Caricare",
        "upTime": "up time",
        "upgrade": "upgrade",
        "video": "Video",
        "vat": "IVA",
        "verificationCode": "Codice di verifica",
        "verticalView": "Vista verticale",
        "withResolution": "Con risoluzione {resolution}",
        "yourPlan": "il tuo abbonamento",
        "youHaveLeftAccount": "Hai abbandonato l'account",
        "zipOrPostalCode": "ZIP",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Gio",
        "fri": "Ven",
        "sat": "Sab",
        "sun": "Dom",
        "apps": "app",
        "multiplePopIdsNotAllowed": "Ciascun file può possedere solo un Identificatore della Prova di Riproduzione.",
        "forbidden": "Qualcosa è andato storto e non è stato possibile completare la tua richiesta. A breve verrai rimandato alla pagina principale.",
        "dataStorageRegion": "Regione di archiviazione dati",
        "verificationSentToEmailIfExist": "Codice di verifica inviato alla tua email (se l'account esiste)",
        "alreadyHaveAnAccountRedirect": "Hai già un account? {linkStart}Accedi{linkEnd}",
        "emailText": "Email",
        "passwordText": "Password",
        "signupWith": "Iscriviti con",
        "setNewPassword": "Imposta password",
        "passwordHint": "{minStart}Minimo 8 caratteri,{minEnd} {upStart}maiuscola,{upEnd} {lowStart}minuscola,{lowEnd} {numStart}numero{numEnd}{numSpecialSeparatorStart} e {numSpecialSeparatorEnd}{spStart}carattere speciale{spEnd}.",
        "home": "Home",
        "loginWithName": "Accedi con {name}",
        "signupWithName": "Iscriviti con {name}",
        "fileType": "Tipo di file",
        "lastModified": "Ultima modifica",
        "images": "Immagini",
        "videos": "Video",
        "projectsOrPdf": "Progetti / PDF",
        "elementiProject": "Progetti Elementi",
        "scheduled": "Pianificato",
        "notScheduled": "Non pianificato",
        "from": "Da",
        "to": "A",
        "fileTypes": "Tipi di file",
        "contentStatus": "Stato del contenuto",
        "modifiedDate": "Data di modifica",
        "filters": "Filtri",
        "sortBy": "Ordina per",
        "sort": "Ordina",
        "lastModifiedDesc": "Ultima modifica (più recente prima)",
        "lastModifiedAsc": "Ultima modifica (più vecchio prima)",
        "nameAsc": "Nome (A → Z)",
        "nameDesc": "Nome (Z → A)",
        "grid": "Griglia",
        "canvas": "Tela",
        "audioPlaylist": "Playlist audio",
        "isAlertActive": "Alert attivo",
        "active": "Attivo",
        "inactive": "Inattivo",
        "filesPage": "Pagina File",
        "ledPage": "Pagina LED",
        "videowallPage": "Pagina Videowall",
        "alertPage": "Pagina Avvisi"
    },
    "buttons": {
        "backToProduct": "Torna a {productName}",
        "reload": "Ricarica",
        "previous": "Precedente",
        "next": "Avanti",
        "loadMore": "Carica altro",
        "addNewUser": "Aggiungi nuovo utente",
        "apply": "Applica",
        "clearAll": "Cancella tutto",
        "reset": "Reimposta",
        "tryItNow": "Provalo ora",
        "switchBack": "Torna alla versione precedente",
        "cancel": "Annulla",
        "deleteMedia": "Elimina media",
        "deletePlayer": "Elimina player",
        "deleteTag": "Elimina tag",
        "deletePopId": "Elimina PoP ID",
        "deleteUser": "Elimina utente",
        "continueWithoutSaving": "Continua senza salvare",
        "close": "Chiudi",
        "cancelOrder": "Annulla l'ordine",
        "removeUser": "Rimuovi utente",
        "deleteTemplate": "Elimina modello",
        "deleteStyle": "Elimina stile",
        "ok": "OK",
        "delete": "Elimina",
        "keepBoth": "Mantieni entrambi",
        "replaceExistingFile": "Sostituisci file esistente",
        "replaceExistingFiles": "Sostituisci file esistenti"
    },
    "texts": {
        "youAreLoggingIn": "Hai effettuato l'accesso con",
        "productAccessDisabled": "Non hai accesso a {product}",
        "productAccessDisabledWarning": "Non hai accesso a {product} per l'account {account}.\n\nO non ti è stato concesso l'accesso a questo prodotto, oppure il tuo accesso è stato revocato dall'Amministratore Globale. Contatta l'Amministratore Globale per ulteriori informazioni o per richiedere l'accesso.\n\nPuoi continuare ad accedere ad altri prodotti che sei autorizzato a utilizzare in questo account.",
        "tablePageCountWTotal": "Visualizzazione di {min}{separator}{max} di {total}",
        "tablePageCountWoutTotal": "Visualizzazione di {min}{separator}{max}",
        "dataStorageRegionHint": "Scegli la regione dove verranno archiviati i dati del tuo account. Questa decisione dovrebbe essere allineata con le tue leggi locali sulla protezione dei dati e le esigenze di conformità. Nota bene: una volta selezionata, la regione di residenza dei dati non può essere modificata successivamente.",
        "welcomeToHUB": "Benvenuto in SpinetiX HUB!",
        "welcomeToHUBDesc": "SpinetiX HUB è la tua piattaforma online all-in-one per gestire tutto ciò che riguarda il tuo digital signage SpinetiX nel cloud.",
        "hubGlobalAdmin": "Amministratore Globale SpinetiX",
        "hubGlobalAdminDesc": "Questo utente è un Amministratore Globale sul HUB, che gli concede automaticamente il ruolo di Amministratore in ARYA. Questa assegnazione di ruolo non può essere modificata.",
        "removeAccessFromAryaTitle": "Rimuovere l'accesso ad ARYA?",
        "removeAccessFromAryaMessage": "Questo rimuoverà solo l'accesso di {userName} ad ARYA.",
        "removeAccessFromAryaByNonGlobalAdmin": "Per rimuovere l'utente dall'account HUB, contatta il tuo Global Admin.",
        "removeAccessFromAryaByGlobalAdmin": "Continueranno ad avere accesso agli altri prodotti in questo account HUB.\n\nPer rimuovere l'utente dall'account HUB, vai a {link}",
        "hubUserManagement": "Gestione utenti HUB",
        "goToHUBUserManagement": "vai alla gestione utenti HUB.",
        "noContentHasBeenScheduledYet": "Nessun contenuto è stato ancora programmato.",
        "emptyFilterTablePlaceholder": "Non abbiamo trovato nessun elemento corrispondente alla tua ricerca. Prova a modificare i termini di ricerca e riprova!",
        "requestId": "ID richiesta:",
        "externalSignInMessage": "Hai effettuato l'accesso con un provider di identità esterno (es. Google, Facebook o SSO con un altro provider di identità). Le tue credenziali, inclusi {email} e {password}, sono gestite da quel provider.",
        "youHaveUnsavedChanges": "Hai modifiche non salvate.",
        "waitForUploadingFile": "Caricamento del file in corso, attendere...",
        "defaultTagsNote": "I progetti ereditano i tag dello Style Pack quando vengono creati dal modello. Se aggiungi o rimuovi tag dallo Style Pack in seguito, i progetti esistenti non verranno aggiornati.",
        "seeAll": "Vedi tutto",
        "allPlayTimes": "Tutti gli orari di riproduzione"
    },
    "switchedAccount": {
        "title": "Account cambiato",
        "desc1": "Bentornato.",
        "switch": "cambia",
        "text1": "Account cambiato",
        "text2": "verso {account}"
    },
    "unsupportedBrowser": {
        "bannerTitle": "Il tuo browser non è supportato",
        "bannerMessage": "Stai utilizzando un browser non supportato. Alcune funzionalità potrebbero non operare correttamente. Per usufruire della migliore esperienza possibile con il nostro prodotto si prega di passare a {highlightStart}Google Chrome{highlightEnd} o {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "plans": {
        "downgradedToFreeDesc": "L'abbonamento {plan} è ora attivo. Un ultimo addebito comparirà sulla tua carta di credito al termine del ciclo di fatturazione",
        "free": "Gratuito",
        "tags": "SMART SYNC & ETICHETTE",
        "sharedStorage": "archiviazione condivisa",
        "custom": "Personalizzazione & Notifiche",
        "playerStorage": "Archiviazione dispositivo",
        "playerPerMonth": "dispositivo / mese | dispositivi / mese",
        "review": {
            "termsAndConditionsMain": "Confermando il tuo ordine accetti",
            "termsAndConditionsSub": "i Termini e Condizioni di Vendita di SpinetiX Terms"
        }
    },
    "filters": {
        "images": "immagini",
        "videos": "video",
        "audio": "audio",
        "projectsOrPdf": "progetti / PDF",
        "scheduled": "programmato",
        "elementiProject": "progetti elementi"
    },
    "template": {
        "24H": "24H",
        "AM/PM": "AM/PM",
        "addPage": "Aggiungi pagina",
        "arrowSettings": "Impostazioni freccia",
        "back": "Indietro",
        "background": "Sfondo",
        "both": "Entrambi",
        "bottom": "in basso",
        "center": "al centro",
        "cellSettings": "impostazioni cella",
        "clock": "orologio",
        "clockSettings": "impostazioni orologio",
        "countdown": "conto alla rovescia",
        "countdownSettings": "impostazioni conto alla rovescia",
        "custom": "personalizzato",
        "changeMedia": "Modifica media",
        "default": "default",
        "duplicatePage": "duplica pagina",
        "date": "data",
        "days": "giorni",
        "effects": "Effetti",
        "fade": "Dissolvenza",
        "fill": "riempimento",
        "front": "Frontale",
        "frameFitting": "Adattamento all'inquadratura",
        "hours": "ore",
        "imageEffects": "Effetti immagine",
        "kenBurns": "Ken Burns",
        "noEffect": "Nessun effetto",
        "noBorder": "Nessun bordo",
        "noMargin": "Nessun margine",
        "L": "L",
        "large": "larga",
        "left": "Sinistra",
        "local": "locale",
        "long": "lungo",
        "M": "M",
        "meet": "unire",
        "media": "media",
        "menu": "menu",
        "mediatable": "tavola media",
        "middle": "medio",
        "month": "mese",
        "overlay": "sovrapposizione",
        "overview": "panoramica",
        "playOnce": "Riproduci una volta",
        "qr": "qr",
        "reg": "reg",
        "repeat": "ripetere",
        "right": "Destra",
        "rss": "RSS",
        "shape": "forma",
        "shapeSettings": "Impostazioni forma",
        "shapeSettingsHint": "Suggerimento: Iniz a a digitare per aggiungere del testo",
        "slice": "fetta",
        "slide": "diapositiva",
        "small": "piccola",
        "smart": "smart",
        "S": "S",
        "time": "ora",
        "timeAndDate": "ORA + DATA",
        "tableSettings": "Impostazioni tavola",
        "text": "testo",
        "textSettings": "Impostazioni testo",
        "top": "in alto",
        "wayfinding": "orientamento",
        "weather": "meteo",
        "html": "pagina web",
        "url": "url",
        "videoin": "Video-In",
        "videoWidth": "larghezza video",
        "videoHeight": "altezza video",
        "videoSettings": "impostazioni video",
        "frameRate": "tasso inquadrature",
        "frameWidth": "Seleziona larghezza",
        "format": "formato",
        "error": {
            "invalidLink": "Link non valido"
        },
        "placeholder": {
            "url": "Inserire URL"
        },
        "weatherIconSettings": "Impostazioni icona meteo",
        "weatherLocationSettings": "Impostazioni località meteo",
        "weatherLocationSettingsHint": "Suggerimento: digita il nome della località",
        "webpageSettings": "Impostazioni pagina web",
        "qrSettings": "Impostazioni QR",
        "rssSettings": "Impostazioni RSS",
        "rssSettingsTooltip": "I feed RSS offerti da {productName} provengono da <b>terze parti fornitrici</b>.<br>Ci impegniamo per fornire una selezione diversificata di feed che soddisfino le tue necessità; la qualità e le prestazioni dei medesimi, tuttavia, dipendono interamente dalle terze parti fornitrici.",
        "stream": "Stream",
        "list": "Lista"
    },
    "templates": {
        "duration": "Durata",
        "pageDuration": "Durata della pagina",
        "timezone": "Fuso orario",
        "tags": "Etichette",
        "playtimes": "Tempo di riproduzione",
        "alignElements": "Allinea elementi",
        "removeTemplateConfirmation": "Sei sicuro di voler eliminare questo modello dallo stile \"{styleName}\"?",
        "deleteStyleConfirmation": "Sei sicuro di voler eliminare lo stile \"{styleName}\"?",
        "deleteStyleWarning": "Eliminando questo stile, rimuoverai tutti i modelli creati al suo interno.",
        "noTemplatesAvailable": "Nessun modello disponibile",
        "noStylePackAccess": "Al momento non hai accesso a nessun pacchetto di stili contenente modelli. I pacchetti di stili sono disponibili solo quando vengono condivisi con te tramite le autorizzazioni o i tag assegnati.\nSe ritieni di dover avere accesso, contatta l'amministratore del tuo account."
    },
    "Hours": {
        "title": "Titolo",
        "time": "Ore",
        "media": "Media"
    },
    "Info": {
        "info": "Info",
        "title": "Titolo",
        "description": "Testo",
        "media": "Media"
    },
    "Logo": {
        "title": "Testo"
    },
    "Menu": {
        "menu": "Menu",
        "title": "Testo",
        "price": "Prezzo",
        "media": "Media"
    },
    "News": {
        "news": "Notizie",
        "title": "Testo",
        "timezone": "Fuso orario",
        "format": "Formato",
        "media": "Media"
    },
    "Person": {
        "person": "Persona",
        "title": "Testo in alto",
        "description": "Testo in basso",
        "media": "Media"
    },
    "Product": {
        "product": "Prodotto",
        "title": "Testo",
        "price": "Prezzo",
        "media": "Media"
    },
    "RSS": {
        "rss-news": "Notizie RSS",
        "rss": "RSS",
        "news": "Notizie"
    },
    "Weather": {
        "weather": "Meteo",
        "locations": "Città",
        "display": "Schermo",
        "media": "Media"
    },
    "playerSetup": {
        "navConfirm": "Conferma",
        "navFinish": "Termina",
        "navNext": "Avanti",
        "navPrev": "Indietro",
        "navCancel": "Annulla",
        "addPlayerToPlan": "Aggiungi dispositivo al tuo abbonamento",
        "currentPlan": "Abbonamento attuale",
        "canvasName": "Nome tela",
        "canvasVideoNote": "Troverai la tua nuova tela in {canvasType} con questa denominazione.",
        "canvasVideoNoteType_led": "Sezione LED",
        "canvasVideoNoteType_videowall": "Sezione Video Wall",
        "canvasSize": "Dimensioni tela",
        "canvasSizeFormatted": "{canvasSize} pixel",
        "updateTo": "Aggiorna a",
        "numberOfPlayers": "Numero di dispositivi",
        "dialogTitle": "Impostazioni dispositivo",
        "onlyDigitsRequired": "Si prega di inserire solo cifre",
        "serialNumberRequired": "Il numero di serie non può essee vuoto",
        "incorrectSerialNumber": "Si prega di inserire il numero di serie corretto",
        "incorrectSerialNumberCharacters": "Si prega di inserire un valore valido. In questo campo è possibile utilizzare solo lettere e numeri inglesi",
        "incorrectInput": "Input non corretto",
        "playerName": "Nome",
        "playerNamePlaceholder": "Nome dispositivo",
        "requiredPlayerName": "Richiesto nome dispositivo",
        "requiredScreenDiagonal": "Richiesta diagonale schermo",
        "requiredHorizontalBezel": "Richiesta lunetta/spazio orizzontale",
        "requiredVerticalBezel": "Richiesta lunetta/spazio verticale",
        "playerTimezoneHint": "Selezionare il fuso orario del dispositivo",
        "Progress_PIN": "PIN",
        "Progress_Name": "Nome & Fuso orario",
        "Progress_DisplaySettings": "Impostazioni schermo",
        "Progress_Application": "Applicazione",
        "Progress_Arrangement": "Sistemazione",
        "Progress_Adjustments": "Regolazioni",
        "DisplayOrientation": "Orientamento schermo",
        "DisplayResolution": "Risoluzione schermo",
        "DisplayResolutionHint": "Seleziona risoluzione schermo",
        "Application": "Applicazione",
        "ApplicationSingleDisplay": "Schermo singoloy",
        "ApplicationMirroring": "Rispecchiamento",
        "ApplicationVideowall": "Video Wall",
        "ApplicationAvailable": "* Disponibile con",
        "ApplicationAvailbleWithNote": "*Disponibile con",
        "screenDiagonal": "Diagonale schermo",
        "SelectApplication": "Seleziona l'applicazione",
        "SelectDisplayOrientation": "Seleziona orientamento schermo",
        "SelectNumberOfDisplays": "Seleziona il numero di schermi",
        "standardScreenOnly": "Solo schermo standard (9:16 & 16:9)",
        "OrientationAndResolution": "Le impostazioni di orientamento e risoluzione verranno applicate a tutti gli schermi",
        "DisplaysArrangement": "Sistemazione schermo",
        "SelectDisplayArrangement": "Seleziona sistemazione schermo",
        "HorizontalBezel": "Lunetta/spazio orizzontale",
        "VerticalBezel": "Lunetta/spazio verticale",
        "OutputResolutions": "Risoluzioni output",
        "CannotCreateLEDTag": "Impossibile creare una risoluzione LED",
        "CannotCreateVideowallTag": "Impossibile creare tela Videowall",
        "UnknownError": "Si è verificato un errore sconosciuto. Si prega di riprovare o di contattare l'assistenza.",
        "InvalidAdjustmentsForm": "Ci sono degli errori di validazione degli input, si prega di completare tutti i campi correttamente",
        "CanvasDimensionsError": "Ampiezza o altezza della tela non generati in maniera corretta",
        "playerDeleteConfirmation": "Sei sicuro di voler eliminare il player: {playerName}?",
        "playerDeleteWarning": "Eliminare il player lo rimuoverà dal tuo account SpinetiX HUB e cancellerà tutte le impostazioni associate, inclusa la pianificazione."
    },
    "planCard": {
        "getPremium": "Ottieni Premium",
        "bestforGettingStarted": "La soluzione migliore per cominciare",
        "discovery": "Scopri",
        "free": "Gratuito",
        "oneUser": "1 utente",
        "oneGBStorage": "1 GB di archiviazione",
        "nineTemplates": "9 template",
        "yourPlan": "Il tuo abbonamento",
        "elevateYourDigitalSignage": "Eleva la tua segnaletica digitale",
        "premium": "Premium",
        "premiumPlanPrice": "21 CHF",
        "playerPerMonth": "Dispositivo / Mese",
        "tenUsersAndRoles": "10 utenti & ruoli utente",
        "tenGBPlayerStorage": "10 GB / Archiviazione dispositivo",
        "twelveTemplatesCustomizable": "12 template / personalizzabili",
        "twelveApps": "12 app inclusa Webpage",
        "elevenApps": "11 app",
        "assetGrouping": "Raggruppamento risorse",
        "scheduleAutomation": "Automazione della programmazione",
        "priorityScheduling": "Programmazione delle priorità",
        "alerts": "Notifiche",
        "audio": "Audio",
        "videoWallSupport": "Assistenza Video Wall*",
        "new": "Novità!",
        "withTheNew": "*Con il nuovo"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "Errore nel reperimento della fattura. Si prega di riprovare.",
        "close": "chiudere",
        "getPremium": "Ottieni Premium!",
        "companyName": "Nome azienda",
        "dialogTitle": "Upgrade abbonamento",
        "navConfirm": "Confermare",
        "navFinish": "TERMINARE",
        "navNext": "Avanti",
        "navPrev": "Indietro",
        "navCancel": "Annulla",
        "VATNumber": "Partita IVA",
        "Overview": "Panoramica",
        "AccountOwner": "Proprietario account",
        "CompanyInfo": "Info azienda",
        "BillingDetails": "Dettagli fatturazione",
        "Payment": "Pagamento",
        "tryAgain": "RIPROVARE",
        "paymentSuccessful": "Pagamento effettuato con successo",
        "welcomeToPremium": "Benvenuto in Premium!",
        "paymentFailed": "Pagamento fallito.",
        "selectCountry": "Selezionare nazione",
        "selectState": "Selezionare Stato"
    },
    "licenseOrdering": {
        "yourOrders": "I tuoi ordini",
        "cancelOrder": "ANNULLA ORDINE",
        "orderNumber": "Ordine numero",
        "orderDate": "Data ordine",
        "comment1": "Commento 1",
        "comment2": "Commento 2",
        "close": "CHIUDERE",
        "cancelOrderWarning": "Sei sicuro di voler annullare questo ordine?",
        "noOrdersAvailable": "Non hai confermato nessun ordine",
        "noRecordsFound": "Nessun risultato trovato per la query query \"{query}\"",
        "noRecordsFoundNote1": "Si prega di controllare che non vi siano errori di battitura o di altro tipo nella propria ricerca",
        "noRecordsFoundNote2": "Prova a utilizzare un'altra query di ricerca"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "Utente non autorizzato ad eseguire aggiornamenti sui media.",
        "hashMD5ComputationError": "Si è verificato un errore durante il calcolo dell'hashMD5.",
        "duplicateFileUploadErrorTitle": "Esiste già un file con questo nome",
        "multipleDuplicateFileUploadErrorTitle": "Esistono già file con questi nomi",
        "duplicateFileUploadErrorDescription": "Un file denominato \"{mediaName}\" esiste già nella tua libreria.",
        "multipleDuplicateFileUploadErrorDescription": "File denominati \"{mediaNames}\" esistono già nella tua libreria.",
        "duplicateFileUploadErrorMessage": "Controlla il/i file esistente/i e scegli cosa vuoi fare con il tuo nuovo caricamento.\n{pleaseNote}: Se sostituisci il file esistente, ricarica la pagina al termine del caricamento per visualizzare la versione aggiornata.",
        "duplicateFileUploadPreviewTitle": "File esistente/i",
        "pleaseNote": "Nota bene"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "Sei sicuro? Questo metodo è esclusivamente per i player che non saranno connessi a Internet.",
        "confirmDownloadLicenseWarning": "L'utilizzo di questo metodo associerà immediatamente la licenza al numero di serie senza periodo di grazia per le modifiche."
    },
    "activation": {
        "assign": "ASSEGNARE",
        "yourLicenses": "Le tue licenze",
        "comment": "Commento",
        "playerSerialNumber": "Numero di serie del dispositivo",
        "licenseCode": "Codice licenza",
        "activationDate": "Data di attivazione",
        "license": "Licenza",
        "suspend": "SOSPENDERE",
        "restore": "RIATTIVARE",
        "download": "SCARICARE",
        "licenseAvailable": "Licenza disponibile ",
        "licenseLockedToAPlayer": "Licenza collegata a un dispositivo",
        "playerSerialNumberRequired": "Richiesto codice numero di serie del dispositivo",
        "licenseCodeRequired": "Richiesto codice licenza",
        "processing": "Procedura in corso",
        "waitingForPlayerToConnect": "Attesa connessione dispositivo",
        "noLicensesAvailable": "Non hai aggiunto alcuna licenza"
    },
    "resolutionCalculator": {
        "invalidPitch": "Spaziatura non valida",
        "invalidSize": "Dimensioni non valide"
    },
    "legal": {
        "legal": "Documenti legali",
        "endUserLicenseAgreement": "ACCORDO DI LICENZA UTENTE FINALE",
        "generalTermsAndConditionsOfSale": "TERMINI E CONDIZIONI DI VENDITA GENERALI",
        "termsOfService": "TERMINI DI SERVIZIO",
        "privacyPolicy": "POLITICA DI RISERVATEZZA",
        "cookieNotice": "AVVISO SUI COOKIE",
        "downloadPDF": "SCARICA PDF"
    },
    "accountSuspended": {
        "bannerTitle": "Il tuo abbonamento è scaduto!",
        "bannerMessage": "Ti preghiamo di contattare il tuo rivenditore qualora desiderassi rinnovarlo."
    },
    "errors": {
        "invalid": {
            "verificationCode": "Il codice di verifica fornito non è valido, riprova.",
            "passwordReset": "La password non può essere reimpostata.",
            "provider": "Provider non valido. Riprova.",
            "emailMismatch": "L’indirizzo email inserito non corrisponde all’account a cui stai tentando di migrare."
        },
        "existing": {
            "userAlreadyLinked": "L’utente è già collegato a un altro Identity Provider (IdP).",
            "accountInAnotherRegion": "L'utente ha già un account in un'altra regione"
        },
        "failedRefreshToken": "Sei stato disconnesso. Accedi nuovamente per continuare.",
        "cannotMigrateAccountInAnotherRegion": "Impossibile migrare a SSO perché il tuo indirizzo email è collegato a una diversa regione di archiviazione dati rispetto all’account a cui stai tentando di migrare.",
        "nonSSOAuthDenied": "L'autenticazione tramite un provider non SSO non è consentita.",
        "ssoMigrationFailed": "Accesso negato: non puoi passare a SSO perché il tuo account è già collegato a un altro Identity Provider (IdP). Contatta l’amministratore per ulteriore assistenza.",
        "loginUnexpectedError": "Accesso non riuscito a causa di un errore imprevisto. Riprova.",
        "unexpectedError": "Si è verificato un errore imprevisto. Si prega di ricaricare la pagina.",
        "somethingWentWrong": "Sembra che qualcosa sia andato storto ({errorCode})",
        "somethingWentWrongDescription": "Si è verificato un errore durante il caricamento di questa pagina.<br><br><strong>Cosa puoi fare:</strong><br>Aggiorna la pagina e riprova.<br>Se non si carica ancora, contatta il supporto e condividi l'ID richiesta riportato di seguito.",
        "failedToUpdateAccountInfo": "Impossibile aggiornare le informazioni dell'account.",
        "failedToFetchLicenses": "Impossibile recuperare le licenze.",
        "failedToDownloadLicense": "Impossibile scaricare la licenza.",
        "failedToDownloadFile": "Impossibile scaricare il file.",
        "failedToFetchUserInfo": "Impossibile recuperare le informazioni utente",
        "failedToFetchPlaces": "Impossibile recuperare i luoghi",
        "fileNotSupported": "Tipo di file non supportato."
    },
    "regionNames": {
        "eu": "Unione Europea / European Union",
        "ch": "Svizzera / Switzerland",
        "us": "Stati Uniti / United States",
        "ca": "Canada / Canada",
        "au": "Australia / Australia",
        "hk": "Hong Kong / Hong Kong",
        "sg": "Singapore / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "Impossibile caricare la chat",
        "chatCouldNotBeLoadedDescription": "Non siamo riusciti a caricare la chat di supporto. Questo di solito è causato dalle impostazioni di privacy o cookie del browser. Per le istruzioni su come abilitare la chat di supporto, clicca qui: {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "Stiamo preparando il tuo contenuto multimediale…",
        "mediaUploadSuccessMessage": "Potrebbe non apparire nella vista corrente a causa di filtri o ordinamento attivi.",
        "mediaViewLegacyToV2Title": "Pagine media riprogettate",
        "mediaViewV2ToLegacyTitle": "Stai utilizzando il nuovo design!",
        "mediaViewSwitcherDescription": "Navigazione più rapida, filtri e ordinamento.",
        "mediaDeleteConfirmation": "Sei sicuro di voler eliminare il media \"{mediaName}\"?",
        "multipleMediaDeleteConfirmation": "Vuoi davvero eliminare i {mediaCount} elementi multimediali selezionati?",
        "mediaDeleteWarning": "L'eliminazione di questo media lo rimuoverà anche da ogni progetto.",
        "multipleMediaDeleteWarning": "L'eliminazione di questi media li rimuoverà anche da ogni progetto che li utilizza.",
        "mediaFileUploadInfoMessage": "Se non li vedi nella tua vista attuale, potrebbero essere nascosti da filtri attivi o ordinamento.",
        "mediaIsReady": "Il tuo media è pronto!",
        "mediaIsReadyWithCount": "Il tuo media è pronto! ({count} di {total})",
        "someFilesUploadError": "Alcuni file non hanno potuto essere elaborati",
        "failedUploadError": "I tuoi file non hanno potuto essere elaborati. Prova a caricarli di nuovo.",
        "failedUploadErrorTitle": "Non abbiamo potuto elaborare il tuo media"
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "Sei sicuro di voler lasciare l'account [{accountName}]?",
        "leaveAccountWarning": "Lasciando questo account, perderai l'accesso all'account e a tutti i prodotti e servizi associati attualmente disponibili."
    },
    "led": {
        "deleteCanvasConfirmation": "Sei sicuro? Questa azione eliminerà questa risoluzione del canvas da tutti i player.",
        "deleteCanvasWarning": "Qualsiasi player che ha utilizzato questa risoluzione del canvas dovrà essere riconfigurato prima che contenuti con la stessa risoluzione possano essere nuovamente pubblicati su di esso."
    },
    "popId": {
        "deletePopIdConfirmation": "Sei sicuro? Questa azione eliminerà questo PoP ID ovunque venga utilizzato."
    },
    "tag": {
        "deleteTagConfirmation": "Sei sicuro? Questa azione eliminerà questo tag da tutti i {source}.",
        "deleteTagWarning": "Ciò potrebbe influire sulle autorizzazioni utente e sulla pianificazione."
    },
    "userProfile": {
        "permanent": "permanente",
        "deleteUserConfirmation": "Stai per eliminare il tuo profilo utente. Questa azione è {permanent} e non può essere annullata.",
        "lose": "perderai",
        "deleteUserWarning": "Procedendo, {lose} l'accesso a tutti gli account e prodotti associati alle tue credenziali utente.\nSei sicuro di voler continuare?"
    }
}
